import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    parametros: [],
    paginaActual: 1,
    registrosPorPagina: 12,
    totalRegistros: 0,
    totalPaginas: 0,
};

const mutations = {
    updateField,

    'INICIALIZAR_PARAMETROS'(state) {
        state.parametros = [];
    },
    'SET_PARAMETROS'(state, parametros) {
        state.parametros = parametros;
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },
};

const actions = {
    getParametros: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_PARAMETROS')

            let queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual

            apiAxios.get('parametrosinflacion' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }
                    commit('SET_PARAMETROS', res.data)

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }, error => {
                reject(error);
            })
    },
    delete () {
        return new Promise((resolve, reject) => {
            apiAxios.post('parametrosinflacion/delete')
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })            
    },
};

const getters = {
    getField,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}